<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="15" height="21" viewBox="0 0 15 21">
		<g transform="translate(-180 -473)">
			<rect width="4" height="21" rx="2" transform="translate(180 473)" fill="currentColor"/>
			<rect width="4" height="21" rx="2" transform="translate(191 473)" fill="currentColor"/>
		</g>
	</svg>
</template>
